'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var ndjson = require('iterable-ndjson');

var configure = require('./lib/configure');

var toIterable = require('stream-to-it/source');

var toCamel = require('./lib/object-to-camel');

module.exports = configure(function (_ref) {
  var ky = _ref.ky;
  return /*#__PURE__*/function () {
    var _ping = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peerId, options) {
      var searchParams, res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              searchParams = new URLSearchParams(options.searchParams);
              searchParams.set('arg', "".concat(peerId));
              if (options.count != null) searchParams.set('count', options.count);
              _context.next = 6;
              return _awaitAsyncGenerator(ky.post('ping', {
                timeout: options.timeout,
                signal: options.signal,
                headers: options.headers,
                searchParams: searchParams
              }));

            case 6:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 9;
              _iterator = _asyncIterator(ndjson(toIterable(res.body)));

            case 11:
              _context.next = 13;
              return _awaitAsyncGenerator(_iterator.next());

            case 13:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 17;
              return _awaitAsyncGenerator(_step.value);

            case 17:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 25;
                break;
              }

              chunk = _value;
              _context.next = 22;
              return toCamel(chunk);

            case 22:
              _iteratorNormalCompletion = true;
              _context.next = 11;
              break;

            case 25:
              _context.next = 31;
              break;

            case 27:
              _context.prev = 27;
              _context.t0 = _context["catch"](9);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 31:
              _context.prev = 31;
              _context.prev = 32;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 36;
                break;
              }

              _context.next = 36;
              return _awaitAsyncGenerator(_iterator.return());

            case 36:
              _context.prev = 36;

              if (!_didIteratorError) {
                _context.next = 39;
                break;
              }

              throw _iteratorError;

            case 39:
              return _context.finish(36);

            case 40:
              return _context.finish(31);

            case 41:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 27, 31, 41], [32,, 36, 40]]);
    }));

    function ping(_x, _x2) {
      return _ping.apply(this, arguments);
    }

    return ping;
  }();
});